import loadable from '@loadable/component';

export const YachtingworldSiteWrapper = loadable(
  () => import(/* webpackChunkName: "yachtingworld-site" */ './YachtingworldSiteWrapper'),
);
